(function () {
  'use strict';

  class InfoMarqueeDropdown extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-dropdown-item]'));

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-dropdown-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', () => this.toggle(item));
      });
    }

    toggle(item) {
      const isOpen = item.classList.contains('is-open');
      // Enforce "only one at a time": close everything first, then reopen
      // the clicked item only if it wasn't already the open one.
      this.items.forEach((otherItem) => this.close(otherItem));
      if (!isOpen) this.open(item);
    }

    open(item) {
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    close(item) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('info-marquee-dropdown')) {
    customElements.define('info-marquee-dropdown', InfoMarqueeDropdown);
  }
})();
